// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"fb2da585","188":"78dfb9b3","487":"23e9cad0","648":"c0760c12"}[chunkId] + ".chunk.js";
};